import React from 'react';
import Moo from '../../../assets/TrustedInsurers/MutualofOmaha.svg';
import MooPng from '../../../assets/TrustedInsurers/MutualofOmaha.png';
import Aetna from '../../../assets/TrustedInsurers/Aetna.svg';
import AetnaPng from '../../../assets/TrustedInsurers/Aetna.png';
import Aig from '../../../assets/TrustedInsurers/AIG.svg';
import AigPng from '../../../assets/TrustedInsurers/AIG.png';
import './TrustedInsurers.css';
import { isMacOS } from '../../../utils/isMacOS';
import { isFirefox } from '../../../utils/isFirefox';
import PhysiciansMutual from '../../../assets/TrustedInsurers/Physicians Mutual.svg';
import PhysiciansMutualPng from '../../../assets/TrustedInsurers/Physicians Mutual.png';
import AAA from '../../../assets/TrustedInsurers/AAA.svg';
import AAApng from '../../../assets/TrustedInsurers/AAA.png';
import ColonialPenn from '../../../assets/TrustedInsurers/ColonialPenn.svg';
import ColonialPennPng from '../../../assets/TrustedInsurers/ColonialPenn.png';
import StateFarm from '../../../assets/TrustedInsurers/State Farm.svg';
import StateFarmPng from '../../../assets/TrustedInsurers/State Farm.png';
import USAA from '../../../assets/TrustedInsurers/USAA.svg';
import USAAPng from '../../../assets/TrustedInsurers/USAA.png';
import AARP from '../../../assets/TrustedInsurers/AARP.svg';
import AARPPng from '../../../assets/TrustedInsurers/AARP.png';
import Trustage from '../../../assets/TrustedInsurers/Trustage.svg';
import TrustagePng from '../../../assets/TrustedInsurers/Trustage.png';
import Aflac from '../../../assets/TrustedInsurers/Aflac.svg';
import AflacPng from '../../../assets/TrustedInsurers/Aflac.png';
import LincolnHeritage from '../../../assets/TrustedInsurers/LincolnHeritage.svg';
import LincolnHeritagePng from '../../../assets/TrustedInsurers/LincolnHeritage.png';

const TrustedInsurers = props => {
  const usePng = !isMacOS() && isFirefox();

  return ( 
    <div className="d-block quoting-logos-mobile">
        <div className="text-center max-400 mx-auto">
          You’re about to compare final expense insurance prices from over 25 insurers:
        </div>
        <div className="row align-items-center mt-3 mt-md-3 px-sm-3 first-row max-400 quoting-logos-grid">
            <div className="quoting-logo-row">
              <div className="mb-md-3 col-md-3">
                <img src={usePng ? PhysiciansMutualPng : PhysiciansMutual} className="PhysiciansMutual" alt="Physicians Mutual" />
              </div>
              <div className="d-flex justify-content-center mb-md-3 col-md-3">
                <img src={usePng ? AAApng : AAA} className="AAA" alt="AAA" />
              </div>
              <div className="mb-md-3 col-md-3 text-center">
                <img src={usePng ? MooPng : Moo} className="MutualOfOmaha" alt="Mutual of Omaha" />
              </div>
            </div>
            <div className="quoting-logo-row">
              <div className="col-md-3">
                <img src={usePng ? ColonialPennPng : ColonialPenn} className="CP" alt="Colonial Penn" />
              </div>
              <div className="mb-md-4 col-md-3">
                <img src={usePng ? StateFarmPng : StateFarm} className="StateFarm" alt="State Farm" />
              </div>
              <div className="mb-md-4 col-md-3 d-flex justify-content-center">
                <img src={usePng ? USAAPng : USAA} className="USAA" alt="USAA" />
              </div>
            </div>
            <div className="quoting-logo-row">
              <div className="mb-md-4 col-md-3 text-center">
                <img src={usePng ? AetnaPng : Aetna} className="AetnaTI" alt="Aetna" />
              </div>
              <div className="mb-md-4 d-sm-block col-md-3">
                <img src={usePng ? AARPPng : AARP} className="AARP" alt="AARP" />
              </div>
              <div className="mb-md-3 col-md-3">
                <img src={usePng ? TrustagePng : Trustage} className="TruStage" alt="Trustage" />
              </div>
            </div>
            <div className="quoting-logo-row">
              <div className="mb-md-3 col-md-3 d-flex justify-content-center">
                <img src={usePng ? AflacPng : Aflac} className="Aflac" alt="Aflac" />
              </div>
              <div className="mb-md-3 col-md-3 text-center">
                <img src={usePng ? LincolnHeritagePng : LincolnHeritage} className="LincolnHeritage" alt="Lincoln Heritage" />
              </div>
              <div className="mb-md-3 col-md-3 d-flex justify-content-center">
                <img src={usePng ? AigPng : Aig} className="AIGTrustedInsurers" alt="AIG" />
              </div>
            </div>
        </div>
    </div>
  );
};

export default TrustedInsurers;
